/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/genre.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Genre
 */
export interface Genre {
    /**
     * @generated from protobuf field: optional string genre = 1;
     */
    genre?: string;
    /**
     * @generated from protobuf field: optional string genre_id = 2;
     */
    genre_id?: string;
    /**
     * duplicate with program.editorial_tag
     *
     * @generated from protobuf field: optional string editorial_tag = 3;
     */
    editorial_tag?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Genre$Type extends MessageType<Genre> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Genre", [
            { no: 1, name: "genre", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "News", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Content genre. Not genre_name because 'genre' asked" } },
            { no: 2, name: "genre_id", kind: "scalar", localName: "genre_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Genre ID." } },
            { no: 3, name: "editorial_tag", kind: "scalar", localName: "editorial_tag", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "BHM", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } }
        ]);
    }
    create(value?: PartialMessage<Genre>): Genre {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Genre>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Genre): Genre {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string genre */ 1:
                    message.genre = reader.string();
                    break;
                case /* optional string genre_id */ 2:
                    message.genre_id = reader.string();
                    break;
                case /* optional string editorial_tag */ 3:
                    message.editorial_tag = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Genre, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string genre = 1; */
        if (message.genre !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.genre);
        /* optional string genre_id = 2; */
        if (message.genre_id !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.genre_id);
        /* optional string editorial_tag = 3; */
        if (message.editorial_tag !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.editorial_tag);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Genre
 */
export const Genre = new Genre$Type();
